import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Component that ensures favicon is always present in the document head
 * This is especially important for SEO and Google search results
 * Uses only favicon.ico as specified
 */
function Favicon() {
  const publicUrl = process.env.PUBLIC_URL || '';
  const baseUrl = 'https://lunarelectric.in';
  
  return (
    <Helmet>
      {/* Favicon - Using favicon.ico only for maximum compatibility and Google search recognition */}
      {/* Absolute URLs first for better SEO and search engine recognition */}
      <link rel="icon" href={`${baseUrl}/favicon.ico`} />
      <link rel="icon" type="image/x-icon" href={`${baseUrl}/favicon.ico`} />
      <link rel="shortcut icon" href={`${baseUrl}/favicon.ico`} />
      {/* Relative paths for local development */}
      <link rel="icon" href={`${publicUrl}/favicon.ico`} />
      <link rel="icon" type="image/x-icon" href={`${publicUrl}/favicon.ico`} />
      <link rel="shortcut icon" href={`${publicUrl}/favicon.ico`} />
      {/* Apple touch icon using favicon.ico */}
      <link rel="apple-touch-icon" href={`${baseUrl}/favicon.ico`} />
      <link rel="apple-touch-icon" href={`${publicUrl}/favicon.ico`} />
    </Helmet>
  );
}

export default Favicon;






